<template>
  <avs-chip
    class="min-width-120"
    color="error"
    icon="mdi-alert-outline"
    iconColor="blue"
    text-color="blue"
  >
    {{ $t("commons.status.overdue") }}
  </avs-chip>
</template>

<script>
export default {
  name: "OverdueChip"
}
</script>
